module.exports = {"150603001":"哈巴格希街道","150603002":"青春山街道","150603003":"滨河街道","150603008":"康新街道","150603400":"鄂尔多斯市高新技术产业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150603.json
// module id = 525
// module chunks = 0